var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVertAlignBottom24Line = function SvgIconVertAlignBottom24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.224H6v1.7h13v-1.7ZM12.5 15.294c.395 0 .78-.165 1.05-.45l3.025-3.175-1.23-1.175-1.995 2.095V5.074h-1.7v7.515l-1.995-2.095-1.23 1.175 3.025 3.175c.27.285.655.45 1.05.45Z",
    fill: "inherit"
  })));
};
export default SvgIconVertAlignBottom24Line;